import {
  tablet as tabletBreakpoint,
} from './variables.scss'

export const tablet = `(max-width: calc(${tabletBreakpoint} - 1px))`
